import { render, staticRenderFns } from "./Gerenciamento.vue?vue&type=template&id=61a09178&scoped=true"
import script from "./Gerenciamento.vue?vue&type=script&lang=js"
export * from "./Gerenciamento.vue?vue&type=script&lang=js"
import style0 from "./Gerenciamento.vue?vue&type=style&index=0&id=61a09178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a09178",
  null
  
)

export default component.exports